// TransactionDetail.jsx
import React, { useState, useEffect } from 'react';
import { 
    Clock, 
    ArrowUp, 
    ArrowDown, 
    Calendar, 
    Building2, 
    CandlestickChart, 
    DollarSign,
    Tag
  } from 'lucide-react';
import { useParams } from "react-router";
import './TransactionDetailPage.css';
import {formatCurrency, formatDateIntl} from "../../util/currency_lookup";

const TransactionDetailPage = () => {
  const [transaction, setTransaction] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { id } = useParams();

  useEffect(() => {
    fetchTransaction();
  }, [id]);

  const fetchTransaction = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/v1/transactions/`+id, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error('Failed to fetch transaction');
      }

      const data = await response.json();
      setTransaction(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="loading">Loading...</div>;
  if (error) return <div className="error">{error}</div>;
  if (!transaction) return <div className="error">No transaction found</div>;

  return (
    <div className="transaction-detail">
      <div className="header">
        <div className="header-content">
          <h1>Transaction Detail</h1>
          <div className={`status ${transaction.status.toLowerCase()}`}>
            {transaction.status}
          </div>
        </div>
        <div className="transaction-id">#{transaction.id}</div>
      </div>

      <div className="transaction-overview">
        <div className="overview-card">
          <div className="overview-title">Transaction Summary</div>
          <div className="overview-content">
            <div className="overview-item">
              {transaction.transaction_type === 'buy' ? (
                <ArrowDown className="icon buy" />
              ) : (
                <ArrowUp className="icon sell" />
              )}
              <span className="transaction-type">{transaction.transaction_type}</span>
            </div>
          </div>
        </div>

        <div className="details-grid">
          <div className="detail-card">
            {/* <div className="detail-label">Date</div>
            <div className="detail-value">{formatDateIntl(transaction.transaction_date)}</div> */}

            <div className="detail-card-content">
              <Calendar className="detail-icon" />
              <div>
                <div className="detail-label">Date</div>
                <div className="detail-value">
                  {formatDateIntl(transaction.transaction_date)}
                </div>
              </div>
            </div>

          </div>
          <div className="detail-card">
            <div className="detail-card-content">
                <Building2 className="detail-icon" />
                <div>
                    <div className="detail-label">Fund Name</div>
                    <div className="detail-value">
                    {transaction.fund_name}
                    </div>
                </div>
                </div>
          </div>
          <div className="detail-card">
            <div className="detail-card-content">
              <DollarSign className="detail-icon" />
              <div>
                <div className="detail-label">Amount</div>
                <div className="detail-value">
                  {formatCurrency(transaction.amount, transaction.currency_code)}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="transaction-details">
        <div className="details-section">
          <h2>Transaction Details</h2>
          <div className="details-content">
            <div className="detail-row">
              <div className="detail-row-content">
                <CandlestickChart className="detail-row-icon" />
                <div className="detail-label">Type</div>
              </div>
              <div className="detail-value">{transaction.transaction_type}</div>
            </div>
            <div className="detail-row">
              <div className="detail-row-content">
                <Clock className="detail-row-icon" />
                <div className="detail-label">Status</div>
              </div>
              <div className={`detail-value status ${transaction.status.toLowerCase()}`}>
                {transaction.status}
              </div>
            </div>
            <div className="detail-row">
              <div className="detail-row-content">
                <Tag className="detail-row-icon" />
                <div className="detail-label">Fund Symbol</div>
              </div>
              <div className="detail-value">{transaction.fund_symbol}</div>
            </div>

          </div>
        </div>
      </div>

      <div className="transaction-details">
        <div className="details-section">
          <h2>User Details</h2>
          <div className="details-content">
            <div className="detail-row">
              <div className="detail-row-content">
                <CandlestickChart className="detail-row-icon" />
                <div className="detail-label">User</div>
              </div>
              <div className="detail-value">{transaction.user_id}</div>
            </div>
            <div className="detail-row">
              <div className="detail-row-content">
                <Tag className="detail-row-icon" />
                <div className="detail-label">Names</div>
              </div>
              <div className="detail-value">{transaction.user_first_name} {transaction.user_last_name}</div>
            </div>

          </div>
        </div>
      </div>

    </div>
  );
};

export default TransactionDetailPage;
